import { ApplicationGoogleDoc } from "@prisma/client";
import { useQuery } from "@tanstack/react-query";

import { fetchApplicationGoogleDocList } from "@/core/client/application/applicationGoogleDoc";

export const useApplicationDocList = (applicationId: string) => {
  return useQuery<ApplicationGoogleDoc[] | null>(
    ["application-google-doc-list", applicationId],
    () => fetchApplicationGoogleDocList(applicationId),
    {
      retry: 1,
      staleTime: 0,
      keepPreviousData: true,
    }
  );
};
